export const initialState = {
  documentTypeId: null,
  changedStateTransitionsPermissions: {},
  deletedStateTransitions: [],
  documentTypeWithStateTransitions: { stateTransitions: [] },
  userGroups: [],
  pager: { page: 0, pageSize: 10 },
  allowSave: false
};

export function reducer(state, action) {
  switch (action.type) {
    case 'OnInitDocumentTypeWithStateTransitions':
      return onInitDocumentTypeWithStateTransitions(state, action);
    case 'OnInitUserGroups':
      return onInitUserGroups(state, action);
    case 'OnChangeStateTransitionsPermission':
      return onChangeStateTransitionsPermission(state, action);
    case 'OnSaving':
      return onSaving(state, action);
    case 'OnSaveFailed':
      return onSaveFailed(state, action);
    case 'OnPageChange':
      return onPageChange(state, action);
    case 'OnRowsPerPageChange':
      return onRowsPerPageChange(state, action);
    case 'OnRemoveStateTransition':
      return onRemoveStateTransition(state, action);
    case 'OnFilterList':
      return onFilterList(state, action);

    default:
      return state;
  }
}

function onFilterList(state, action) {
  return {
    ...state,
    documentTypeWithStateTransitions: action.documentTypeWithStateTransitions,
    userGroups: action.userGroups,
    pager: {
      ...state.pager,
      page: 0
    }
  };
}

function onInitDocumentTypeWithStateTransitions(state, action) {
  const { documentTypeWithStateTransitions } = action;
  return {
    ...state,
    documentTypeId: documentTypeWithStateTransitions.id,
    documentTypeWithStateTransitions: documentTypeWithStateTransitions,
    changedAllowedStatesPermissions: {},
    deletedStateTransitions: [],
    allowSave: false
  };
}

function onInitUserGroups(state, action) {
  const { userGroups } = action;
  return {
    ...state,
    userGroups: userGroups
  };
}

function onChangeStateTransitionsPermission(state, action) {
  const { stateTransitionId, userGroupId, value } = action;
  const changedState = !state.changedStateTransitionsPermissions[stateTransitionId]
    ? {}
    : state.changedStateTransitionsPermissions[stateTransitionId];
  return {
    ...state,
    allowSave: true,
    changedStateTransitionsPermissions: {
      ...state.changedStateTransitionsPermissions,
      [stateTransitionId]: { ...changedState, [userGroupId]: value }
    }
  };
}

function onSaving(state) {
  return {
    ...state,
    allowSave: false
  };
}

function onSaveFailed(state) {
  return {
    ...state,
    allowSave: true
  };
}

function onPageChange(state, action) {
  const { page } = action;
  return {
    ...state,
    pager: {
      ...state.pager,
      page: page
    }
  };
}

function onRowsPerPageChange(state, action) {
  const { pageSize } = action;
  return {
    ...state,
    pager: {
      ...state.pager,
      pageSize: pageSize,
      page: 0
    }
  };
}

function onRemoveStateTransition(state, action) {
  const { stateTransitionId } = action;
  const filtered = state.documentTypeWithStateTransitions.stateTransitions.filter(x => x.id !== stateTransitionId);
  const pager =
    state.pager.page > 0 && filtered.length <= (state.pager.page - 1) * state.pager.pageSize
      ? { ...state.pager, page: --state.pager.page }
      : state.pager;
  return {
    ...state,
    pager: pager,
    allowSave: true,
    deletedStateTransitions: [...state.deletedStateTransitions, stateTransitionId],
    documentTypeWithStateTransitions: {
      ...state.documentTypeWithStateTransitions,
      stateTransitions: [...filtered]
    }
  };
}
